import useChartOptions from '@/features/charts/hooks/options/useChartOptions';
import useSpotOptions from '@/features/charts/hooks/options/useSpotOptions';
import RegularChart from '@/features/charts/RegularChart';
import { generateMockSeries } from '@/test-utils/fixtures/chartSeries.mock';

const mockData = [generateMockSeries()];

const UnauthenticatedChart = () => {
  const { createOptions } = useSpotOptions(14);
  const { options: chartOptions } = useChartOptions(mockData, createOptions);
  return (
    <RegularChart
      chartSeries={mockData}
      error={false}
      height={14}
      loading={false}
      options={chartOptions}
      showLegend={false}
    />
  );
};
export default UnauthenticatedChart;
